import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false
}: CtaButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <motion.a href={href} onClick={handleClick} className={`
        relative inline-flex items-center justify-center 
        bg-miel-red hover:bg-miel-crimson text-white 
        font-bold text-lg md:text-xl py-4 px-8 rounded-full 
        shadow-[0_0_20px_rgba(155,27,48,0.4)] hover:shadow-[0_0_30px_rgba(155,27,48,0.6)]
        transition-all duration-300 border border-miel-crimson/50
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 15px rgba(155,27,48,0.4)', '0px 0px 25px rgba(155,27,48,0.7)', '0px 0px 15px rgba(155,27,48,0.4)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-45">
      {children}
    </motion.a>;
}